import type { ChannelsTranslation } from './types';

export const channelsHi: ChannelsTranslation = {
  nav: 'चैनल',
  title: 'चैनल',
  description: 'ईमेल, WhatsApp और Telegram का जवाब उसी इनबॉक्स से दें जिसमें आपकी वेब चैट आती है।',
  loading: 'चैनल लोड हो रहे हैं',
  guide: 'चैनल कैसे काम करते हैं',
  brand: 'ब्रांड',
  list: '{{brand}} के चैनल',
  forbidden: {
    title: 'आप चैनल नहीं सँभाल सकते',
    description: 'वर्कस्पेस के मालिक या एडमिन से ऐसी भूमिका माँगें जिसमें इंटीग्रेशन सँभालने की अनुमति हो।',
  },
  noBrands: {
    title: 'अभी कोई ब्रांड नहीं है',
    description: 'पहले एक ब्रांड जोड़ें। फिर उसके चैनल यहाँ जोड़ें।',
    action: 'ब्रांड और इंस्टॉल पर जाएँ',
  },
  kind: {
    web: 'वेब चैट',
    email: 'ईमेल',
    whatsapp: 'व्हाट्सऐप',
    telegram: 'टेलीग्राम',
    other: 'अन्य',
  },
  status: {
    connected: 'जुड़ा हुआ',
    needs_attention: 'ध्यान चाहिए',
    paused: 'रुका हुआ',
  },
  problem: 'Chatwoot का संदेश: {{problem}}',
  web: {
    text: 'आपकी वेबसाइट का चैट विजेट।',
    link: 'चैट विजेट की सेटिंग',
  },
  conversations_one: 'इस हफ़्ते {{count}} बातचीत',
  conversations_other: 'इस हफ़्ते {{count}} बातचीतें',
  lastMessage: 'आख़िरी संदेश: {{time}}',
  noMessages: 'अभी कोई संदेश नहीं',
  ai: {
    label: 'यहाँ AI जवाब दे',
    hint: 'बंद: हर बातचीत का जवाब आपकी टीम देती है। चालू: पहले AI जवाब देता है और ज़रूरत पड़ने पर बातचीत आपकी टीम को सौंप देता है।',
    on: 'अब {{name}} पर पहले AI जवाब देता है।',
    off: 'अब {{name}} पर हर बातचीत का जवाब आपकी टीम देती है।',
  },
  team: {
    label: 'टीम',
    none: 'कोई टीम नहीं (रूटिंग तय करे)',
    hidden: 'ऐसी टीम जो आपको नहीं दिखती',
    saved: '{{name}} पर नई बातचीतें अब {{team}} को जाती हैं।',
    cleared: '{{name}} पर नई बातचीतें किसे मिलें, यह अब रूटिंग तय करती है।',
  },
  pause: {
    action: 'रोकें',
    label: '{{name}} को रोकें',
    title: '{{name}} को रोकें?',
    body: 'जब तक आप फिर से शुरू नहीं करते, इस चैनल की नई बातचीतें Chatwoot में ही रहेंगी। जो बातचीतें यहाँ आ चुकी हैं, वे चलती रहेंगी।',
    confirm: 'चैनल रोकें',
    done: '{{name}} रोक दिया गया।',
  },
  resume: {
    action: 'फिर शुरू करें',
    label: '{{name}} फिर शुरू करें',
    done: '{{name}} फिर से चल रहा है।',
  },
  unclaimed: {
    text: 'आपके Chatwoot खाते में मिला।',
    action: 'इस ब्रांड के लिए इस्तेमाल करें',
    done: '{{name}} अब {{brand}} के लिए जवाब देता है।',
  },
  empty: {
    title: 'अभी कोई ईमेल, WhatsApp या Telegram चैनल नहीं है।',
    description:
      'अपना सपोर्ट ईमेल, WhatsApp Business नंबर या Telegram बॉट यहीं जोड़ें। Chatwoot में जोड़े गए चैनल "नए चैनल खोजें" से यहाँ दिखते हैं।',
  },
  check: {
    action: 'नए चैनल खोजें',
    busy: 'खोज रहे हैं…',
    found_one: '{{count}} नया चैनल मिला',
    found_other: '{{count}} नए चैनल मिले',
    none: 'कोई नया चैनल नहीं मिला',
  },
  email: {
    connect: {
      action: 'ईमेल जोड़ें',
      title: 'ईमेल जोड़ें',
      step: '{{total}} में से चरण {{step}}',
      steps: {
        address: 'आपका पता',
        imap: 'आने वाली मेल (IMAP)',
        smtp: 'जाने वाली मेल (SMTP)',
        answering: 'जवाब कौन देगा',
      },
      intros: {
        address: 'वह पता जिस पर आपके ग्राहक लिखते हैं।',
        imap: 'Chatwoot नए ईमेल इसी सर्वर से पढ़ता है।',
        smtp: 'आपके जवाब इसी पते से, इस सर्वर के ज़रिए भेजे जाते हैं।',
        answering: 'चुनें कि यहाँ ईमेल का जवाब कौन देगा। बाद में इसे कार्ड पर बदल सकते हैं।',
      },
      guide: 'ईमेल कैसे जोड़ें',
      back: 'पीछे',
      next: 'आगे',
      submit: 'जोड़ें',
      busy: 'आपका मेलबॉक्स जाँचा जा रहा है…',
      busyHint: 'जोड़ने से पहले Chatwoot आपके मेलबॉक्स में साइन इन करके देखता है। इसमें थोड़ा समय लग सकता है।',
      done: 'ईमेल जुड़ गया। नए ईमेल आपके इनबॉक्स में दिखेंगे।',
    },
    fields: {
      address: 'सपोर्ट पता',
      addressHint: 'जैसे help@yourshop.com।',
      name: 'Studio में नाम',
      nameDefault: 'सपोर्ट ईमेल',
      nameHint: 'यह नाम सिर्फ़ आपकी टीम को दिखता है।',
      provider: 'ईमेल प्रोवाइडर',
      providerNone: 'अपना प्रोवाइडर चुनें',
      custom: 'कोई और प्रोवाइडर',
      find: 'मेरी सेटिंग ढूँढें',
      found: '{{provider}} की सेटिंग भर दी गई है।',
      unknown:
        'इस पते की सेटिंग हमें नहीं पता। अपने ईमेल प्रोवाइडर से उसके IMAP और SMTP सर्वर पूछें और अगले चरणों में भरें।',
      server: 'सर्वर',
      imapServer: 'आने वाली मेल का सर्वर',
      smtpServer: 'जाने वाली मेल का सर्वर',
      port: 'पोर्ट',
      imapPort: 'आने वाली मेल का पोर्ट',
      smtpPort: 'जाने वाली मेल का पोर्ट',
      ssl: 'SSL इस्तेमाल करें',
      sslHint: 'इसे चालू रखें, जब तक आपका प्रोवाइडर कुछ और न कहे।',
      login: 'लॉगिन',
      imapLogin: 'आने वाली मेल का लॉगिन',
      smtpLogin: 'जाने वाली मेल का लॉगिन',
      loginHint: 'आम तौर पर आपका पूरा ईमेल पता।',
      imapPassword: 'आने वाली मेल का पासवर्ड',
      smtpPassword: 'जाने वाली मेल का पासवर्ड',
      security: 'सुरक्षा',
      securityNone: 'कोई नहीं',
      noneHint: 'सुरक्षा के बिना आपका पासवर्ड बिना हिफ़ाज़त के भेजा जाता है। इसे तभी चुनें जब आपका प्रोवाइडर कहे।',
      sameLogin: 'आने वाली मेल वाला ही लॉगिन और पासवर्ड',
      show: '{{field}} दिखाएँ',
      hide: '{{field}} छिपाएँ',
    },
    appPassword: {
      title: 'ऐप पासवर्ड इस्तेमाल करें',
      text: 'आपका प्रोवाइडर आपके सामान्य पासवर्ड की जगह ऐप पासवर्ड माँगता है।',
      link: 'ऐप पासवर्ड बनाएँ',
    },
    microsoft: {
      title: 'Microsoft को Chatwoot में जोड़ें',
      text: 'Microsoft अब ईमेल ऐप के लिए पासवर्ड स्वीकार नहीं करता। Outlook या Microsoft 365 को Chatwoot में जोड़ें (Settings → Inboxes → Email → Microsoft), फिर "नए चैनल खोजें" इस्तेमाल करें।',
      blocked: 'पासवर्ड के साथ आगे बढ़ने के लिए कोई और प्रोवाइडर चुनें।',
    },
    errors: {
      name: 'एक नाम लिखें, ज़्यादा से ज़्यादा 100 अक्षर।',
      address: 'एक ईमेल पता लिखें, जैसे help@yourshop.com।',
      server: 'सर्वर का नाम लिखें, जैसे mail.yourshop.com।',
      port: '1 से 65535 तक का पोर्ट लिखें।',
      login: 'लॉगिन लिखें। यह आम तौर पर आपका ईमेल पता होता है।',
      password: 'पासवर्ड लिखें।',
      newPassword: 'नया पासवर्ड लिखें, या मौजूदा पासवर्ड ही रखें।',
    },
    settings: {
      action: 'ईमेल सेटिंग',
      label: '{{name}} की ईमेल सेटिंग',
      title: 'ईमेल सेटिंग',
      loading: 'ईमेल सेटिंग लोड हो रही है',
      general: 'पता',
      incoming: 'आने वाली मेल (IMAP)',
      outgoing: 'जाने वाली मेल (SMTP)',
      change: 'पासवर्ड बदलें',
      changeLabel: '{{field}} बदलें',
      keep: 'मौजूदा पासवर्ड रखें',
      kept: 'पासवर्ड जैसा है वैसा ही रहेगा।',
      save: 'सेव करें',
      busy: 'आपका मेलबॉक्स जाँचा जा रहा है…',
      done: 'ईमेल सेटिंग सेव हो गई।',
    },
    fix: {
      action: 'साइन-इन ठीक करें',
      label: '{{name}} का साइन-इन ठीक करें',
      hint: 'Chatwoot इस मेलबॉक्स में साइन इन नहीं कर पा रहा। ऐसा अक्सर पासवर्ड बदलने के बाद होता है। नया पासवर्ड लिखें।',
    },
  },
  whatsapp: {
    connect: {
      action: 'WhatsApp जोड़ें',
      title: 'WhatsApp जोड़ें',
      steps: {
        number: 'आपका नंबर',
        answering: 'जवाब कौन देगा',
        webhook: 'Meta का वेबहुक सेट करें',
      },
      intros: {
        number: 'Meta के Cloud API पर आपका WhatsApp Business नंबर।',
        answering: 'चुनें कि यहाँ WhatsApp संदेशों का जवाब कौन देगा। बाद में इसे कार्ड पर बदल सकते हैं।',
        webhook: 'आख़िरी चरण: Meta को बताएँ कि आपके ग्राहकों के संदेश कहाँ भेजने हैं।',
      },
      guide: 'WhatsApp कैसे जोड़ें',
      submit: 'जोड़ें',
      busy: 'Meta से जाँच हो रही है…',
      busyHint: 'नंबर जोड़ने से पहले Chatwoot आपके ऐक्सेस टोकन को Meta से जाँचता है। इसमें थोड़ा समय लग सकता है।',
      connected: 'आपका WhatsApp नंबर जुड़ गया। अब Meta का वेबहुक सेट करें।',
      done: 'WhatsApp जुड़ गया। Meta का वेबहुक सेट होते ही संदेश आपके इनबॉक्स में आने लगेंगे।',
    },
    fields: {
      nameDefault: 'व्हाट्सऐप',
      phoneNumber: 'बिज़नेस फ़ोन नंबर',
      phoneNumberHint: '+ और देश कोड के साथ, जैसे +971 50 123 4567।',
      phoneNumberId: 'फ़ोन नंबर ID (Phone number ID)',
      businessAccountId: 'WhatsApp बिज़नेस अकाउंट ID (WhatsApp Business Account ID)',
      accessToken: 'ऐक्सेस टोकन',
      accessTokenHint: 'यह सीधे Chatwoot को जाता है। Studio इसे नहीं रखता।',
    },
    help: {
      title: 'ये कहाँ मिलेंगे',
      text: 'ये Meta के WhatsApp Manager → API setup में मिलेंगे। किसी system user का स्थायी ऐक्सेस टोकन इस्तेमाल करें।',
      link: 'Meta की Cloud API गाइड',
    },
    errors: {
      phoneNumber: 'नंबर + और देश कोड के साथ लिखें, जैसे +971501234567।',
      phoneNumberId: 'Phone number ID लिखें। इसमें सिर्फ़ अंक होते हैं।',
      businessAccountId: 'WhatsApp Business Account ID लिखें। इसमें सिर्फ़ अंक होते हैं।',
      accessToken: 'ऐक्सेस टोकन लिखें। यह कम से कम 20 अक्षर लंबा होता है।',
    },
    setup: {
      action: 'Meta सेटअप',
      label: '{{name}} का Meta सेटअप',
      title: 'Meta का वेबहुक सेट करें',
      loading: 'Meta सेटअप लोड हो रहा है',
      instructions:
        'Meta के App Dashboard → WhatsApp → Configuration → Webhook में ये दोनों चिपकाएँ, Verify and save चुनें, फिर messages को सब्सक्राइब करें।',
      callbackUrl: 'कॉलबैक URL (Callback URL)',
      verifyToken: 'वेरिफ़ाई टोकन (Verify token)',
      copy: 'कॉपी करें',
      copyLabel: '{{field}} कॉपी करें',
      noToken: 'Chatwoot ने अभी Verify token नहीं बनाया है। थोड़ी देर बाद Meta सेटअप फिर खोलें।',
      done: 'हो गया',
    },
  },
  telegram: {
    connect: {
      action: 'Telegram जोड़ें',
      title: 'Telegram जोड़ें',
      intro: 'अपना Telegram बॉट जोड़ें। लोग बॉट को जो संदेश भेजते हैं, वे आपके इनबॉक्स में आते हैं।',
      guide: 'Telegram कैसे जोड़ें',
      submit: 'जोड़ें',
      busy: 'Telegram से जाँच हो रही है…',
      done: 'Telegram {{bot}} के रूप में जुड़ गया। नए संदेश आपके इनबॉक्स में दिखेंगे।',
      doneUnnamed: 'Telegram जुड़ गया। नए संदेश आपके इनबॉक्स में दिखेंगे।',
    },
    fields: {
      nameDefault: 'टेलीग्राम',
      botToken: 'बॉट टोकन',
      botTokenHint: 'यह सीधे Chatwoot को जाता है। Studio इसे नहीं रखता।',
    },
    help: {
      title: 'बॉट टोकन पाएँ',
      text: 'Telegram पर @BotFather को संदेश भेजें, /newbot भेजें और जो टोकन वह दे, उसे कॉपी करें।',
      link: 'BotFather पर Telegram की गाइड',
    },
    errors: {
      botToken: '@BotFather से मिला टोकन लिखें। यह 123456789:AAH… जैसा दिखता है, बिना स्पेस के।',
    },
  },
  reply: {
    email: 'आपका जवाब ईमेल से भेजा जाता है।',
    whatsapp: 'आपका जवाब WhatsApp पर भेजा जाता है।',
    telegram: 'आपका जवाब Telegram पर भेजा जाता है।',
    minutesLeft_one: 'आप बस एक मिनट और जवाब दे सकते हैं।',
    minutesLeft_other: 'आप {{count}} मिनट और जवाब दे सकते हैं।',
    closed:
      'WhatsApp अब सिर्फ़ टेम्पलेट संदेशों की अनुमति देता है। ग्राहक के दोबारा लिखने के बाद आप फिर जवाब दे सकते हैं।',
  },
  templates: {
    button: 'टेम्पलेट',
    open: 'टेम्पलेट भेजें',
    title: 'WhatsApp टेम्पलेट भेजें',
    description:
      'ग्राहक का कोई संदेश आए 24 घंटे बीत जाने पर WhatsApp सिर्फ़ वही टेम्पलेट पहुँचाता है जिन्हें Meta ने मंज़ूरी दी हो।',
    loading: 'टेम्पलेट लोड हो रहे हैं',
    search: 'टेम्पलेट खोजें',
    category: {
      UTILITY: 'सेवा',
      MARKETING: 'मार्केटिंग',
      AUTHENTICATION: 'पुष्टि',
      other: 'अन्य',
    },
    unsupported: {
      not_approved: 'Meta की मंज़ूरी का इंतज़ार है',
      authentication: 'एक बार वाले कोड आपके अपने सिस्टम भेजते हैं',
      media_header: 'फ़ोटो, वीडियो या दस्तावेज़ वाले हेडर के टेम्पलेट अभी यहाँ से नहीं भेजे जा सकते',
    },
    synced: 'टेम्पलेट आख़िरी बार {{time}} अपडेट हुए।',
    syncHint: 'Chatwoot के Meta से सिंक करने के बाद नए टेम्पलेट यहाँ दिखते हैं।',
    empty: {
      title: 'अभी कोई मंज़ूर टेम्पलेट नहीं',
      description:
        'Meta के WhatsApp Manager में एक टेम्पलेट बनाएँ। Meta की मंज़ूरी और Chatwoot के सिंक करने के बाद वह यहाँ दिखेगा।',
      guide: 'टेम्पलेट संदेश कैसे काम करते हैं',
    },
    noMatch: '“{{query}}” से कोई टेम्पलेट मेल नहीं खाता।',
    back: 'सभी टेम्पलेट',
    fields: {
      title: 'भरें',
      none: 'इस टेम्पलेट में भरने के लिए कुछ नहीं है।',
      header: 'हेडर {{variable}}',
      body: 'संदेश {{variable}}',
      button: 'बटन “{{label}}”',
      prefilled: 'इस बातचीत से भरा गया।',
      code: 'कोड, 15 अक्षरों तक।',
      url: 'बटन के लिंक के अंत में जोड़ा जाता है।',
    },
    preview: 'पूर्वावलोकन',
    send: 'टेम्पलेट भेजें',
    missing_one: 'भेजने के लिए एक और मान भरें।',
    missing_other: 'भेजने के लिए {{count}} और मान भरें।',
    errors: {
      required: 'इसे भरें।',
      code: 'कोड में ज़्यादा से ज़्यादा 15 अक्षर हो सकते हैं।',
    },
    sent: 'टेम्पलेट भेजा गया।',
  },
  chatwoot: {
    title: 'Chatwoot ने जवाब नहीं दिया',
    description: 'थोड़ी देर में फिर कोशिश करें।',
  },
};
